import { useMemo } from "react";
import type {
	ClientPropertyCottageDetailResponseDTO,
	ClientPropertyVehicleDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";

type PropType = { key: string; label: string };

export const useGetPropertyOptionalParams = (
	propTypes: PropType[],
	data:
		| ClientPropertyCottageDetailResponseDTO
		| ClientPropertyVehicleDetailResponseDTO,
	t: (key: string) => string,
): { properties: string } => {
	const properties = useMemo(
		() =>
			propTypes
				.filter(({ key }) => (data as any)[key])
				.map(({ label }) => t(label))
				.join(", "),
		[data, t],
	);

	return { properties };
};
